module.exports = __webpack_public_path__ + "img/confidentleader1_new.cac192db.png";